// removed by extract-text-webpack-plugin
module.exports = {"MobileCard":"_3qDX15HON5qbbxs0__YcKO","MobileCardHeader":"_2eA5X3TylrFz6RE6jbGmMA","MobileProjectName":"_16MXxtPoAg4oS1QfgSNGoj","FavoriteIcon":"_2gNO3UUW0v0scOEur-orcv","MobileSettingsLink":"_1lb3M0a8R9hpCoEcuOhypr","SettingsIcon":"uDxjzIWTpQW6OAsKumsZk","MobileWebsite":"_1zLMFD1rPpB7EmxyE0n4Ns","MobileMetrics":"_2pWd1lGlyFfUCWgpxFgN8U","MobileLabel":"_3pzoeT-N-PTyYsgNNKUHnC","MobileValue":"tnGxh7XmPPtSo8_ropuRr"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ProjectMobileCard/styles.module.css
// module id = 568
// module chunks = 0